import apiClient from './client';
import type { Pedido, CreatePedidoRequest, PaginatedResponse } from '@/types';

export const pedidosService = {
  async getPedidos(params: {
    limit?: number;
    empresa?: number;
  }): Promise<PaginatedResponse<Pedido>> {
    const { data } = await apiClient.get<PaginatedResponse<Pedido>>('/pedidos', { params });
    return data;
  },

  async getPedidoById(id: string, empresaId: number): Promise<Pedido> {
    const { data } = await apiClient.get<Pedido>(`/pedidos/${id}`, {
      params: { empresa: empresaId }
    });
    return data;
  },

  async createPedido(pedido: CreatePedidoRequest): Promise<{ success: boolean; message?: string; pedidoId?: string }> {
    const { data } = await apiClient.post('/pedidos', pedido);
    return data;
  },

  async updatePedido(id: number, pedido: CreatePedidoRequest): Promise<Pedido> {
    const { data } = await apiClient.put<Pedido>(`/pedidos/${id}`, pedido);
    return data;
  },

  async deletePedido(id: number): Promise<void> {
    await apiClient.delete(`/pedidos/${id}`);
  },
};
